import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { PunchCardRow } from './punch-card-row';
export var punchCardKey = 'punch-card';
var PunchCard = /** @class */ (function (_super) {
    __extends(PunchCard, _super);
    function PunchCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderAxisLabel = function (x) { return (React.createElement("span", { key: "axis-label-" + x, className: 'axis-label' }, _this.props.xAxisTickLabel ? _this.props.xAxisTickLabel(x) : x)); };
        _this.maybeRenderPunchCardAxis = function () {
            var props = _this.props;
            var strips = props.value;
            if (!strips.length) {
                return null;
            }
            else {
                var xValues = strips[0].points.map(function (p) { return p.x; });
                return (React.createElement("div", { className: 'punch-card-axis' }, xValues.map(function (x) { return _this.renderAxisLabel(x); })));
            }
        };
        _this.renderStrip = function (value) { return (React.createElement(PunchCardRow, { key: value.id, value: value, tooltipLabel: _this.props.tooltipLabel })); };
        return _this;
    }
    PunchCard.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var cn = namespacedClassnames(punchCardKey);
        var punchCardRows = props.value.map(function (strip) { return _this.renderStrip(strip); });
        var punchCardAxis = this.maybeRenderPunchCardAxis();
        return (React.createElement("div", { className: cn },
            React.createElement("div", { className: 'punchcard-rows-wrapper' }, punchCardRows),
            punchCardAxis));
    };
    return PunchCard;
}(React.PureComponent));
export { PunchCard };
//# sourceMappingURL=index.js.map